export default {"src":"https://kroemtech.ch//_next/static/media/arrowsSet.e820aefa.svg","height":250,"width":72,"blurWidth":0,"blurHeight":0};